
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visa",
      function () {
        return require("private-next-pages/visa/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visa"])
      });
    }
  